import tw, { css, styled } from 'twin.macro'

import { Plus, Triangle } from 'react-feather'
import { Link } from 'gatsby'

export const HeroSection = styled.section`
	${tw`flex flex-col w-full items-center bg-center bg-no-repeat bg-cover relative overflow-hidden mb-12`}
	background-image: url(${({ sources }) => sources[0].base64});

	@media (min-width: 320px) {
		height: 230px;
		max-height: 230px;
	}

	@media (min-width: 525px) {
		height: 320px;
		max-height: 320px;
	}

	@media (min-width: 768px) {
		height: 440px;
		max-height: 440px;
	}

	@media (min-width: 1024px) {
		height: 580px;
		max-height: 580px;
	}
	@media (min-width: 1280px) {
		height: 650px;
		max-height: 650px;
	}
`
export const HeroItemsContainer = styled.div`
	${tw`absolute flex flex-col w-full m-auto items-center justify-center h-full pb-4 pt-8 lg:p-0`}
	top:0;
	left: 0;
	right: 0;

	> img {
		@media(min-width: 320px) and (max-width:766px) {
			${tw`w-8/12`}
		}
		${tw`md:w-7/12 xl:w-5/12 xxl:w-6/12 xxxl:w-4/12`}
	}

	${tw`bg-cover bg-no-repeat bg-center`}
	@media (min-width: 320px) {
		${tw`bg-bottom`}
		background-image: url(${({ sources }) => (sources ? sources[0].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[0].src : '')});
	}
`

export const DescriptionSection = tw.section`w-full mb-12`
export const DescriptionContainer = tw.div`w-11/12 lg:w-9/12 xxxl:w-8/12 mx-auto`
export const Heading1 = tw.h1`font-display text-blue-600 text-4xl text-center font-bold mb-8`
export const Paragraph = tw.p`text-xl text-center mx-auto font-display`
export const ListContainer = tw.div`mt-8`
export const ListTitle = styled(Paragraph)`
	${tw`mb-8`}
`
export const List = tw.ul`grid col-gap-4 row-gap-6 grid-cols-1 md:grid-cols-2`
export const ListItem = tw.li`flex flex-row p-4 shadow-md`
export const ItemDetails = tw.div`flex flex-col ml-8 justify-center`
export const ItemImg = tw.img`w-24`
export const ItemTitle = tw.h3`font-display uppercase text-blue-500 font-bold text-lg`
export const ItemDescription = tw.p`font-display`
export const MineralSwimBannerContainer = tw.div`w-11/12 xl:w-10/12 xxl:w-9/12 xxxl:w-8/12`
export const FilterBannerText = styled.h2`
	@media (min-width: 525px) and (max-width: 767px) {
		${tw`text-4xl w-6/12`}
	}
	${tw`font-display text-3xl md:text-5xl lg:text-6xl text-white font-bold w-6/12 md:w-7/12 xl:w-6/12 xxxl:w-5/12 mr-auto`}
`
export const FilterBannerP = styled.p`
	@media (min-width: 525px) and (max-width: 767px) {
		${tw`text-3xl w-6/12`}
	}
	${tw`font-display text-2xl md:text-4xl lg:text-5xl text-white w-6/12 md:w-7/12 xl:w-6/12 xxxl:w-5/12 mr-auto mt-6`}
`
export const FilterSection = styled.div`
	${tw`w-11/12 xl:w-10/12 xxl:w-9/12 xxxl:w-8/12 py-10 mx-auto -mt-16 md:-mt-28 bg-white px-2 mb-16 bg-white`}
	box-shadow: 2px 15px 30px 5px rgba(0,0,0,0.35);
`
export const ProductSeries = styled.p`
	${tw`text-2xl text-center font-display mb-4`}
	span {
		${tw`font-bold`}
	}
`
export const ProductName = styled.p`
	${tw`font-line text-center text-4xl text-blue-700 font-bold mb-4`}

	> span {
		${tw`font-display text-blue-500`}
	}
`
export const ProductImgContainer = styled.div`
	max-height: 400px;
	${tw`flex items-center justify-center my-8 md:my-16 lg:my-8 md:w-6/12`}
	&:hover {
		img {
			opacity: 0.875;
		}
	}
	img {
		${tw`h-full`}
		@media (min-width: 325px) {
			max-height: 200px;
		}

		@media (min-width: 525px) {
			max-height: 300px;
		}
	}
	@media (min-width: 325px) {
		max-height: 200px;
	}

	@media (min-width: 525px) {
		max-height: 300px;
	}
	@media (min-width: 768px) {
		max-height: 220px;
	}
	@media (min-width: 1024px) {
		max-height: 300px;
	}
`
export const ProductsContainer = styled.div`
	${tw`w-full m-auto flex flex-col md:flex-row flex-wrap`}

	> div:not(:last-of-type) {
		${tw`mb-4`}
	}
`
export const ProductSpace = tw.div`w-full mx-auto`
export const ProductItem = styled.div`
	box-shadow: 0 10px 5px -5px rgba(0, 0, 0, 0.1),
		0 10px 10px -5px rgba(0, 0, 0, 0.04);
	${tw`flex flex-col w-full h-full`}
`
export const Products = tw.div`bg-gray-200 py-8 xl:py-12 w-full`
export const ProductsHolder = styled.div`
	@media (min-width: 525px) {
		${tw`w-full`}
	}
	${tw`w-11/12 xl:w-10/12 xxl:w-9/12 xxxl:w-8/12 m-auto overflow-hidden flex flex-col`}
	@media (max-width: 524px) {
		width: 90%;
	}
`
export const ProductTitle = tw.h3`text-lg md:text-xl lg:text-2xl xl:text-3xl italic font-display font-bold text-blue-700 bg-white text-center p-4 mb-auto xl:mb-3 w-full`
export const FilterProductSection = tw.section`w-full bg-white`
export const FilterBannerSection = styled.section`
	height: 550px;
	min-height: 550px;
	${tw`w-full bg-cover bg-no-repeat bg-center`}
	background-color: #c5cbc0;
	background-image: url(${({ sources }) => sources[0].base64});

	@media (min-width: 768px) and (max-width: 1023px) {
		height: 450px;
		min-height: 450px;
	}
	@media (min-width: 325px) and (max-width: 767px) {
		height: 350px;
		min-height: 350px;
	}
`
export const FilterBannerContainer = styled.div`
	@media (min-width: 525px) {
		${tw`pl-8`}
	}
	${tw`flex flex-col w-full h-full pl-4 xl:pl-24 items-center justify-center`}
	${tw`bg-cover bg-no-repeat`}
	min-height: 550px;
	@media (min-width: 325px) and (max-width: 524px) {
		height: 350px;
		min-height: 350px;
		background-image: url(${({ sources }) => sources[6].srcWebp});
		background-image: url(${({ sources }) => sources[6].src});
	}
	@media (min-width: 525px) {
		height: 400px;
		min-height: 400px;
		background-image: url(${({ sources }) => sources[5].srcWebp});
		background-image: url(${({ sources }) => sources[5].src});
	}
	@media (min-width: 768px) {
		height: 500px;
		min-height: 500px;
		background-image: url(${({ sources }) => sources[4].srcWebp});
		background-image: url(${({ sources }) => sources[4].src});
	}
	@media (min-width: 1024px) {
		background-position: right;
		height: 550px;
		min-height: 550px;
		background-image: url(${({ sources }) => sources[3].srcWebp});
		background-image: url(${({ sources }) => sources[3].src});
	}
	@media (min-width: 1280px) {
		background-image: url(${({ sources }) => sources[2].srcWebp});
		background-image: url(${({ sources }) => sources[2].src});
	}
	@media (min-width: 1400px) {
		background-image: url(${({ sources }) => sources[1].srcWebp});
		background-image: url(${({ sources }) => sources[1].src});
	}
	@media (min-width: 1700px) {
		background-image: url(${({ sources }) => sources[0].srcWebp});
		background-image: url(${({ sources }) => sources[0].src});
	}
`
export const FilterHeading = styled.p`
	@media (min-width: 525px) {
		${tw`ml-6`}
	}
	${tw`text-base text-xl lg:text-3xl xl:text-4xl xxxl:text-5xl font-display items-baseline ml-3 items-center font-bold`}

	> span {
		${tw`text-blue-600 font-line`}
	}
`
export const AddOnSection = tw.section`w-full`
export const AddOnContainer = tw.div`flex flex-col`
export const AddOnParagraph = styled.p`
	${tw`w-full text-center text-white text-xl xxxl:text-2xl md:px-16 xxl:px-24 xxxl:px-32 font-display py-16`}
	background-color: #abbccf;
`
export const BannerProductHolder = styled.div`
	${tw`flex flex-col md:flex-row`}
`
export const BannerHolder = styled.div`
	/* height: 1000px; */
	min-height: 1000px;
	${tw`w-full md:w-6/12 bg-cover bg-no-repeat bg-center`}
	background-color: #c5cbc0;
	background-image: url(${({ sources }) => sources[0].base64});

	@media (min-width: 1024px) and (max-width: 1279px) {
		min-height: 900px;
	}
	@media (min-width: 768px) and (max-width: 1023px) {
		min-height: 800px;
	}
	@media (min-width: 320px) and (max-width: 767px) {
		min-height: 500px;
	}
`
export const BannerContainer = styled.div`
	${tw`flex flex-col w-full h-full pl-4 xl:pl-24 relative`}
	${tw`bg-cover bg-no-repeat`}

	@media (min-width: 320px) {
		background-image: url(${({ sources }) => sources[1].srcWebp});
		background-image: url(${({ sources }) => sources[1].src});
	}
	@media (min-width: 1280px) {
		background-image: url(${({ sources }) => sources[0].srcWebp});
		background-image: url(${({ sources }) => sources[0].src});
	}
	@media (min-width: 320px) and (max-width: 767px) {
		height: 500px;
		min-width: 500px;
	}
`
export const ProductHolder = styled.div`
	${tw`py-4 lg:py-8 xxxl:py-12 px-3 lg:px-5 xl:px-10 xxxl:px-16 w-full md:w-6/12 flex justify-center items-center bg-gray-100`}
	> ul {
		> li {
			${tw`w-full p-2 lg:p-3 xl:p-4 xxl:p-6 shadow-lg`}
		}

		> li:not(:last-of-type) {
			${tw`mb-6 xxxl:mb-8`}
		}
	}
`
export const BannerContents = styled.div`
	${tw`absolute left-0 right-0 pl-8 lg:pl-16 pr-8 py-4 md:py-10`}
	bottom: 5%;
	background-color: rgba(171, 188, 207, 0.8);

	> h2 {
		${tw`text-5xl xl:text-7xl font-display text-white font-bold mb-6`}
		text-shadow: 2px 4px 8px rgba(0,0,0,0.3);

		+ p {
			${tw`text-xl font-display text-white`}
			text-shadow: 2px 4px 8px rgba(0,0,0,0.3);
		}
	}
`
export const TableSection = tw.div`bg-white py-4 md:py-8 mb-4 md:mb-4`
export const TableContainer = tw.div`w-11/12 mx-auto md:w-full overflow-x-scroll md:overflow-auto`
export const TableElement = styled.table`
	${tw`w-11/12 xl:w-10/12 xxl:w-9/12 xxxl:w-8/12 mx-auto`}

	> thead tr th {
		${tw`font-line font-bold text-mineral-teal text-2xl pb-6`}
	}
	> tbody tr td {
		${tw`w-3/12 py-3 font-display`}
		border-color: #fff #fff #58c8df;
		min-width: 200px;
	}
	> tbody tr td > ul > li:not(:last-of-type) {
		${tw`mb-2`}
	}
	> tbody tr td > ul > li {
		> span {
			${tw`px-3 relative`}
		}
		> span:before {
			${tw`absolute bg-gray-900 rounded-full`}
			content: '';
			left: -5px;
			top: 5px;
			height: 7px;
			width: 7px;
		}
	}
	> tbody tr:not(:first-of-type) td:not(:first-of-type) {
	}
	> tbody tr:not(:last-of-type) td:first-of-type {
		${tw`border-b-2`}
	}
	> tbody tr td:first-of-type {
		${tw`pl-3 font-bold bg-white border-r-8`}
	}

	> tbody tr td:not(:first-of-type) {
		${tw`px-2 text-center normal-case`}
	}

	> tbody tr:nth-child(odd) {
		background: linear-gradient(to right, #ebecf0 0%, #e8e9ed 2%, #c3c4ca 100%);
	}

	tbody tr:first-of-type td:not(:first-of-type) {
		${tw`border-b-8 border-solid border-mineral-teal`} /* border-image:linear-gradient(90deg, rgba(233,236,241,1) 0%, rgba(84,120,152,1) 100%);
		border-image-slice: 1; */
	}
`
export const AddOnList = tw.ul`flex flex-col w-full`
export const AddOnListItem = tw.li`flex flex-row justify-center bg-white`
export const AddOnItemDetails = styled.div`
	${tw`flex flex-col ml-2 lg:ml-6 w-3/5 lg:w-6/12 items-center`}

	> svg {
		${tw`w-36 lg:w-48 xl:w-auto`}
	}
`
export const AddOnProductImg = styled.picture`
	${tw`w-9/12 lg:w-7/12 xxl:w-6/12 cursor-pointer`}
	> img {
		${tw`mx-auto`}
		max-height: 180px;
	}
`
export const PhDrive = tw.p`text-blue-500 font-display text-4xl xl:text-5xl font-thin`
export const AddOnItemDesc = tw.p`mt-4 font-display text-blue-700 text-sm xl:text-base`
export const AddOnImages = tw.div`flex flex-row w-2/5 lg:w-6/12 justify-center items-center cursor-pointer`
export const AddOnButtons = tw.div`flex flex-col mt-3 lg:mt-6`
export const AddOnAddToCart = tw.button`rounded-md bg-yellow-500 border border-yellow-500 hover:bg-yellow-400 text-white text-sm xl:text-base font-display py-2 xl:py-3 uppercase px-8 xl:px-16`
export const AddOnEnquireNow = styled(AddOnAddToCart)``
export const PlusSvg = styled(Plus)`
	${tw`hidden lg:block mr-3 w-5/12 xxl:w-6/12 cursor-pointer`}
	stroke-linecap: square;
	@media (max-width: 1023px) {
		top: calc(44% - 2.5rem);
	}
`
export const AddOnDetails = styled(AddOnAddToCart)`
	${tw`bg-transparent hover:bg-blue-600 border border-blue-600 text-blue-600 hover:text-white mt-2`}
`
export const EndBannerSection = styled.section`
	${tw`flex flex-col w-full items-center bg-center bg-no-repeat bg-cover relative overflow-hidden`}
	background-image: url(${({ sources }) => sources[0].base64});

	@media (min-width: 320px) {
		height: 300px;
		max-height: 300px;
	}

	@media (min-width: 525px) {
		height: 350px;
		max-height: 350px;
	}

	@media (min-width: 768px) {
		height: 400px;
		max-height: 400px;
	}

	@media (min-width: 1280px) {
		height: 450px;
		max-height: 450px;
	}
`
export const EndBannerContainer = styled.div`
	${tw`absolute flex flex-col w-full m-auto justify-center h-full pb-4 pt-8 lg:pb-0 lg:pt-0`}
	top:0;
	left: 0;
	right: 0;

	${tw`bg-cover bg-no-repeat bg-center`}
	@media (min-width: 320px) {
		background-image: url(${({ sources }) =>
			sources ? sources[2].srcWebp : ''});
		background-image: url(${({ sources }) => (sources ? sources[2].src : '')});
	}
	@media (min-width: 768px) {
		background-image: url(${({ sources }) =>
			sources ? sources[1].srcWebp : ''});
		background-image: url(${({ sources }) => (sources ? sources[1].src : '')});
	}
	@media (min-width: 1024px) {
		background-image: url(${({ sources }) =>
			sources ? sources[0].srcWebp : ''});
		background-image: url(${({ sources }) => (sources ? sources[0].src : '')});
	}
`
export const EndItemImage = tw.img`w-11/12 sm:w-10/12 lg:w-auto`
export const EndBannerText = styled.p`
	${tw`text-white font-display text-3xl sm:text-4xl lg:text-5xl`}
	text-shadow: 10px 6px 8px rgba(0,0,0,.75);
`
export const EndDetailsContainer = tw.div`w-7/12 lg:w-6/12 ml-4 sm:ml-8 lg:ml-16`
export const EndBannerButton = tw.button`py-3 px-4 bg-yellow-500 hover:bg-yellow-400 rounded mt-8`
export const EndBannerLink = styled(Link)`
	${tw`text-white uppercase font-display`}
`
export const Enquire = styled(Link)`
	${tw`font-display w-full md:w-6/12 uppercase border-2 border-yellow-600 hover:border-yellow-500 bg-yellow-600 hover:bg-yellow-500 text-white py-2 px-6 rounded cursor-pointer md:mr-2 mb-2 md:mb-0 text-center`}
	&[disabled] {
		${tw`cursor-not-allowed`}
	}
`
export const HeroButtons = styled.div`
	@media (min-width: 525px) {
		${tw`flex-row mt-4`}
	}
	${tw`flex flex-col mt-2 lg:mt-8`}
`
export const HeroSeeAllLink = styled(Link)`
	@media (min-width: 525px) {
		${tw`mb-0 mr-2`}
	}
	${tw`border border-yellow-500 bg-yellow-500 text-gray-800 hover:border-yellow-400 hover:bg-yellow-400 rounded mb-2 mr-0`}
`
export const HeroSeeAll = styled.button`
	@media (min-width: 525px) {
		${tw`text-sm`}
	}
	${tw`font-sans uppercase text-xs md:text-base py-2 lg:py-4 px-8 leading-none w-full`}
`
export const HeroBookLink = styled(Link)`
	@media (min-width: 525px) {
		${tw`ml-2`}
	}
	${tw`border border-mineral-teal rounded bg-mineral-teal hover:bg-blue-600 hover:border-blue-600 ml-0 text-center`}
`
export const HeroBook = styled.button`
	@media (min-width: 525px) {
		${tw`text-sm`}
	}
	${tw`font-display text-white leading-none text-xs md:text-base uppercase py-2 lg:py-4 px-8 `}
`
export const NoAddon = tw.p`text-3xl font-bold font-display text-blue-600 text-center`
export const TermsImg = styled.img`
	${tw`hover:opacity-75 cursor-pointer`}
`

export const HeroTermsLink = styled(Link)`
	@media (min-width: 525px) {
		${tw`ml-2 mr-2 mb-0`}
	}
	${tw`border-2 border-white bg-white hover:bg-dolphin-gray rounded-lg ml-0 mb-2`}
`
export const HeroTerms = styled.button`
	@media (min-width: 525px) {
		${tw`text-sm`}
	}
	${tw`font-sans text-dolphin-gray hover:text-white leading-none text-xs md:text-base uppercase py-3 lg:py-4 px-8`}
`
